import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function EbookBanner() {
  const { pathname } = useLocation();
  // Ocultar en la propia landing de la guía
  if (pathname === "/guia-estres" || pathname.startsWith("/guia-")) return null;

  return (
    <div className="bg-emerald-50 border-b border-emerald-100 py-2 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
        <span className="text-sm text-slate-600 hidden sm:inline">
          Guía práctica para estrés e insomnio
        </span>
        <span className="text-xs text-slate-600 sm:hidden">
          Guía: Estrés e Insomnio
        </span>
        <Link
          to="/guia-estres"
          className="inline-flex items-center gap-1 text-emerald-700 font-semibold text-sm hover:underline"
        >
          Ver guía <ArrowRight size={13} aria-hidden="true" />
        </Link>
      </div>
    </div>
  );
}
